import axios, { AxiosError, AxiosResponse } from 'axios';
import { CmsError } from './CmsError';

const http = axios.create();

http.interceptors.response.use(
    function (response: AxiosResponse) {
        if (response?.data?.result === 'fail') {
            const cmsError = new CmsError(
                `Failed to ${response.config.method} ${response.config.url}`,
                response
            );
            return Promise.reject(cmsError);
        }

        return response;
    },
    function (error: AxiosError) {
        if (error.response?.data?.result === 'fail') {
            const cmsError = new CmsError(
                `Failed to ${error.config.method} ${error.config.url}`,
                error.response
            );
            return Promise.reject(cmsError);
        }

        return Promise.reject(error);
    }
);

export { http };
